function removeTypename<T>(entity: T): T;
function removeTypename<T>(entity: T[]): T[];
function removeTypename<T>(entity: T | T[]): T | T[] {
  const remove = (e: T): T => {
    // tslint:disable-next-line: no-string-literal
    delete e['__typename'];
    return e;
  };

  if (Array.isArray(entity)) {
    return entity.map(e => ({ ...e })).map(remove);
  } else {
    return remove({ ...entity });
  }
}

const graphql = {
  removeTypename
};

export { graphql };
